import Poster from "../components/poster/poster";
import About from "../components/about/about";
import Service from "../components/services/service";
import Team from "../components/team/team";
import Blog from "../components/blog/blog";
import User from "../components/users/user";
import Contact from "../components/contact/contact";
function Homepage(){
    return(
        <>
        <div className="homepage">
<Poster/>
<About/>
<Service/>
<Team/>
<Blog/>
<User/>
<Contact/>
        </div>
        </>
    )
}
export default Homepage